import OGCMapTileClass, * as OGCMapTileModule from './../../node_modules/ol/source/OGCMapTile.js';

class OGCMapTile extends OGCMapTileClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in OGCMapTileModule) {
    if (key !== "default") {
        OGCMapTile[key] = OGCMapTileModule[key];
    }
}

export default OGCMapTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/OGCMapTile.js';